<div class="screen-overlay" (click)="close(true)"></div>
<div class="side-nav-content">
<ng-container *ngTemplateOutlet="contentTpl"></ng-container>
<ng-template #contentTpl><ng-content></ng-content></ng-template>
</div>